import { RegrelloIcon, type RegrelloIconName, type RegrelloIntent } from "@regrello/ui-core";

export type DocumentTypeName = "CAD" | "Excel" | "Image" | "PDF" | "Word" | "Other";

export function getDocumentIcon(documentTypeName: string) {
  return <RegrelloIcon {...getIconProps(documentTypeName)} />;
}

export function getIconProps(documentTypeName: string): {
  iconName: RegrelloIconName;
  className?: string;
  intent?: RegrelloIntent;
} {
  switch (documentTypeName) {
    case "CAD":
      return { iconName: "file-cad" };
    case "Excel":
      return { iconName: "file-excel", intent: "success" };
    case "Image":
      return { iconName: "file-image", intent: "secondary" };
    case "PDF":
      return { iconName: "file-pdf", intent: "danger" };
    case "Word":
      return { iconName: "file-word", intent: "primary" };
    default:
      return { iconName: "file" };
  }
}

/**
 * Determines the document type based on file extension
 *
 * @private
 */
function getDocumentTypeFromExtension(fileExtension: string): DocumentTypeName {
  switch (fileExtension.toLowerCase()) {
    case "xls":
    case "xlsx":
    case "csv":
      return "Excel";
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
      return "Image";
    case "dwg":
    case "dxf":
    case "cad":
      return "CAD";
    case "doc":
    case "docx":
      return "Word";
    case "pdf":
      return "PDF";
    default:
      return "Other";
  }
}

export function getDocumentTypeFromFileExtension(fileExtension: string): string {
  return getDocumentTypeFromExtension(fileExtension);
}
